import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { TableHeader } from "./TableHeader";
import BackButton from "../../../../components/utils/BackButton";
import Loader from "../../../../components/utils/Loader";
import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { fetchInventoryForm, fetchRawsListInventoryForm, setActiveModalAction } from "../../../../action";
import ReactTooltip from "react-tooltip";
import { isEmpty, groupBy } from "lodash";
import { ItemRow } from "./ItemRow";
import {utils, writeFileXLSX} from 'xlsx';
import {formatDateTime} from "../../../../utils/formatDateTime";
import {styles} from "../../../../containers/goods/styles";
import {inventoryFormLoadingSelector, inventoryFormSelector} from "../../../../selectors/forms";
import { categoryRawListSelector } from '../../../../selectors/raw';
import { fetchProductCategories } from '../../../../action/raw';
import { fetchFilials } from '../../../../action/handbook';
import { getGoodWithReceipeData } from '../../../../action/recipes';
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import request from '../../../../action/utils/request';
import { urls } from '../../../../constants/app';
import { parseNumToFixed, roundToFixed } from '../../../../utils/common';

const DetailInventoryForm = ({ match }) => {
    const { id } = match.params;
    const dispatch = useDispatch();
    const viewMode = new URLSearchParams(window.location.search).get('viewMode');
    const form = useSelector(state => inventoryFormSelector(state, id));
    const loading = useSelector(state => inventoryFormLoadingSelector(state, id));
    const isMobile = window.innerWidth <= 1024;
    const productscategories = useSelector(categoryRawListSelector);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const [groupedProducts, setGroupedProducts] = useState([]);
    const [loadingRawsForm, setLoadingRawsForm] = useState(true);

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(productscategories)) dispatch(fetchProductCategories());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, productscategories]);

    const openChangeLog = () => dispatch(setActiveModalAction({ field: 'changeLogAccountingModal', value: { id: form.id, changeLog: form.changeLog, created_at: form.created_at, type: 'inventory' }}));
 
    const getViewRaws = async (raws, semis, date, point) => {
        const rawDataFromSemis = [];
        
        for (const semi of semis) {
            if (semi.quantity === 0) continue;
            if (semi.productscategory && semi.productscategory.id) {
                const receipeData = !isEmpty(semi.receipeData) ? semi.receipeData : await dispatch(getGoodWithReceipeData({id: semi.rawmaterial.id, type: 'semi' }, true, date));
                if (receipeData.error) continue;
                if (receipeData && isEmpty(semi.receipeData)) await request({ method: 'put', url: `${urls.rawmaterialsinventories}/${semi.id}`, data: { receipeData }});
                receipeData.forEach((rawData) => {
                    let quantity = null;
                    if (rawData.count) {
                        quantity = rawData.count && (rawData.count['default'] || 0) * semi.quantity;
                    } else {
                        quantity = rawData.quantity && (rawData.quantity['default'] || 0) * semi.quantity;
                    }
                    rawDataFromSemis.push({ id: semi.id, rawmaterial: {id: rawData.id}, quantity, isSemi: true });
                });
            }
        };

        const result = await Promise.all(
            raws.map(async (raw) => {
                const semisData = rawDataFromSemis.filter((semi) => semi.rawmaterial.id === raw.rawmaterial.id);
                if (isEmpty(semisData) && raw.totalPrice != null) return { ...raw, sum: raw.totalPrice };
                const quantity = !isEmpty(semisData) ? semisData.reduce((acc, item) => {
                    return acc += parseFloat(item.quantity) || 0
                }, (parseFloat(raw.quantity) || 0)) : parseFloat(raw.quantity);
    
                let sum = 0;
                let count = quantity;
                let invoicesIds = [];

                if (raw.totalPrice != null) return { ...raw, quantity, sum: raw.totalPrice };
                while (count !== 0) {
                    const params = {
                        point: point ? point.id ? point.id : point : null,
                        date_lte: date,
                        _sort: 'date:desc',
                        _limit: 1,
                        rawsIds: [raw.id],
                    };

                    if (invoicesIds.length > 0) params['id_nin'] = invoicesIds;
    
                    const invoiceData = await request({ method: 'post', url: `${urls.invoiceforms}/listInventory`, data: params });
                    const invoice = !isEmpty(invoiceData) ? invoiceData[0] : null;
                    if (!invoice) break;
                    invoicesIds.push(invoice.id);
                    if (!invoice.rawMaterials || invoice.rawMaterials.length === 0) continue;
    
                    const dataRaw = invoice.rawMaterials.find((el) => el.id === raw.id);
                    if (!dataRaw) continue;
                    
                    sum += dataRaw.totalPrice;
                    count -= dataRaw.quantity;
                    if (count === 0) break;
                }
    
                const last_price = (raw && raw.rawData && raw.rawData.last_price) ? +raw.rawData.last_price : (raw && raw.rawmaterial && raw.rawmaterial.last_price) ? raw.rawmaterial.last_price : null;
                if (count !== 0) sum += count * last_price;
    
                await request({ method: 'put', url: `${urls.rawmaterialsinventories}/${raw.id}`, data: { totalPrice: sum }});
                return { ...raw, quantity, sum };
            })
        )

        const groupedRawMaterials = groupBy(
            result,
            (item) =>
                (item && item.productscategory && item.productscategory.title) ||
                "Без категории"
        );
        
        return {groupedRawMaterials, groupedSemiManufactures: null}
    }

    useEffect(() => {
        const loadForm = async () => {
            if (id) {
                setLoadingRawsForm(true);
                let result = null;
                if (form && form.id === parseInt(id, 10)) {
                    result = form;
                } else {
                    result = await dispatch(fetchInventoryForm(id, true));
                }
                if (result && !result.error) {
                    const rawMaterials = await dispatch(fetchRawsListInventoryForm(result.id));
                    if (rawMaterials) {
                        const rawsInventory = (rawMaterials || []).map((raw) => {
                            if (!isEmpty(raw.rawmaterial)) {
                                const rawData = raw.rawmaterial;
                                const productscategory = (rawData.productscategory && rawData.productscategory.id) ? rawData.productscategory : productscategories.find((category) => category.id === rawData.productscategory);
                                return { ...raw, productscategory }
                            }

                            if (!isEmpty(raw.rawData)) {
                                const rawData = raw.rawData;
                                const productscategory = productscategories.find((category) => category.id === rawData.categoryId);
                                if (!isEmpty(productscategory)) return { ...raw, rawmaterial: { name: rawData.name, id: rawData.id }, productscategory };
                                return { ...raw, rawmaterial: { name: rawData.name, id: rawData.id }, productscategory: { id: rawData.categoryId, title: rawData.categoryName, type: rawData.type } };
                            }

                            return null;
                        }).filter((item) => item);                  

                        if (viewMode !== 'view') {
                            const groupedRawMaterials = groupBy(
                                rawsInventory.filter((item) => item.productscategory.type === 'raw' && !item.productscategory.notBalance),
                                (item) =>
                                    (item && item.productscategory && item.productscategory.title) ||
                                    "Без категории"
                            );

                            const groupedSemiManufactures = groupBy(
                                rawsInventory.filter((item) => item.productscategory.type === 'semi' && !item.productscategory.notBalance),
                                (item) =>
                                    (item && item.productscategory && item.productscategory.title) ||
                                    "Без категории"
                            );

                            setGroupedProducts({groupedRawMaterials, groupedSemiManufactures});
                        } else {
                            const semis = rawsInventory.filter((item) => item.productscategory.type === 'semi'  && !item.productscategory.notBalance);
                            const raws = rawsInventory.filter((item) => item.productscategory.type === 'raw'  && !item.productscategory.notBalance);
                            const data = await getViewRaws(raws, semis, result.date, result.point);
                            setGroupedProducts(data);
                        }
                    }

                    setLoadingRawsForm(false);
                }
            }
        };
        if (!isEmpty(productscategories)) loadForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, id, form, productscategories, viewMode]);

    const textStyles = {
        display: "block",
        width: "auto",
        height: "38px",
        padding: "0.65rem 1rem",
        fontSize: "1rem",
        fontWeight: "400",
        lineHeight: "1.5",
        color: "#495057",
        backgroundColor: "#fff",
        backgroundClip: "padding-box",
        border: "1px solid #e2e5ec",
        borderRadius: "4px",
        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        boxShadow: "none",
        outline: "none",
        whiteSpace: "nowrap",
    };

    const dateInfo = form.date ? formatDateTime(form.date) : '';

    const renderGroupedItems = (groupedItems, isSemiManufacture = false) => {
        return Object.entries(groupedItems).sort(([a], [b]) => a.localeCompare(b)).map(([category, items]) => (
            <React.Fragment key={category}>
                <tr
                    className="kt-datatable__row"
                    style={{fontWeight: 'bold'}}
                >
                    <td colSpan="3" className="kt-datatable__cell">{category}</td>
                </tr>
                {items.sort((a, b) => {
                    const aHasName = a.rawmaterial && a.rawmaterial.name;
                    const bHasName = b.rawmaterial && b.rawmaterial.name;

                    if (!aHasName && !bHasName) return 0;
                    if (!aHasName && bHasName) return 1;
                    if (aHasName && !bHasName) return -1;
                    return a.rawmaterial.name.localeCompare(b.rawmaterial.name);
                }).map((item) => (
                    <ItemRow
                        key={item.id}
                        item={item}
                        style={textStyles}
                        isSemiManufacture={isSemiManufacture}
                        viewMode={viewMode}
                        isMobile={isMobile}
                    />
                ))}
            </React.Fragment>
        ));
    };

    const calcualteTotalSum = (groupedItems, type) => {
        if (isEmpty(groupedItems) || !type) return 0;
        const getPlanBalance = (item) => {
            return (item.prevInventory || 0) + (item.coming || 0) - (item.expenditure || 0) - (item.writeoff || 0);
        }

        const totalSum = Object.values(groupedItems).reduce((total, items) => {
            total += items.reduce((acc, item) => {
                const planBalance = parseNumToFixed(getPlanBalance(item), 3);
                const difference = parseNumToFixed(parseFloat(item.quantity - planBalance), 3);
                const rawData = item.rawmaterial;
                const sum = item.sum ? parseNumToFixed(item.sum) : parseNumToFixed(parseFloat(rawData.last_price * difference)) || 0
    
                if (type === 'shortage' && planBalance > item.quantity) {
                    acc += parseFloat(sum);
                } else if (type === 'surplus' && planBalance <= item.quantity) {
                    acc += parseFloat(sum);
                }
    
                return acc;
            }, 0);
            return roundToFixed(total) || 0;
        }, 0);

        if (type === 'shortage') return Math.abs(totalSum || 0)
        return roundToFixed(totalSum) || 0;
    }

    const getPlanBalance = (item) => {
        return (item.prevInventory || 0) + (item.coming || 0) - (item.expenditure || 0) - (item.writeoff || 0);
    }

    const onExportShortage = () => {
        if (viewMode !== 'view') return;
        const groupedItems = groupedProducts.groupedRawMaterials;

        const getFirstSheet = () => {
            const exportData = [];

            exportData.push({
                'Филиал': pointAdress || 'Нет данных',
                'Дата': dateInfo || 'Нет данных',
            }, {});

            Object.entries(groupedItems).forEach(([category, items]) => {
                const shortageItems = items.filter((item) => {
                    const planBalance = parseNumToFixed(getPlanBalance(item), 3);
                    if (planBalance > item.quantity) return true;
                    return false;
                });
    
                if (!isEmpty(shortageItems)) {
                    exportData.push({
                        'Id': '',
                        'Название': category,
                    });
    
                    shortageItems.forEach((item) => {
                        const rawData = item.rawmaterial;
                        let unitName = MEASURES_RAW[rawData.measure] || 'Нет данных';
                        const name = rawData ? rawData.name : 'Нет данных';
                        const planBalance = parseNumToFixed(getPlanBalance(item), 3);
                        const difference = parseNumToFixed(parseFloat(item.quantity - planBalance), 3);
                        const quantity = item.quantity != null ? parseNumToFixed(item.quantity, 3) || 0 : 0;
                        
                        exportData.push({
                            'Id': item.id,
                            'Название': name,
                            'Единица измерения': unitName,
                            'Остаток (план.)': planBalance || 0,
                            'Остаток (факт.)': quantity,
                            'Недостача': difference || 0,
                            'Сумма недостачи': item.sum ? Math.abs(+item.sum) : Math.abs(+parseNumToFixed(parseFloat(rawData.last_price * difference))) || 0,
                        });
                    });
                }
            });

            exportData.push(
                {
                    'Название': '',
                },
                {
                    'Название': 'Итого',
                },
                {
                    'Название': 'Общая сумма недостачи',
                    'Сумма недостачи': calcualteTotalSum(groupedItems, 'shortage'),
                }
            );

            return exportData;
        };

        const getSecondSheet = () => {
            const exportData = [];

            exportData.push({
                'Филиал': pointAdress || 'Нет данных',
                'Дата': dateInfo || 'Нет данных',
            }, {});

            Object.entries(groupedItems).forEach(([category, items]) => {
                const shortageItems = items.filter((item) => {
                    const planBalance = parseNumToFixed(getPlanBalance(item), 3);
                    if (planBalance > item.quantity) return true;
                    return false;
                });
    
                if (!isEmpty(shortageItems)) {
                    const shortage = shortageItems.reduce((acc, item) => {
                        const rawData = item.rawmaterial;
                        const planBalance = parseNumToFixed(getPlanBalance(item), 3);
                        const difference = parseNumToFixed(parseFloat(item.quantity - planBalance), 3);
                        const sum = item.sum ? +item.sum : +parseNumToFixed(parseFloat(rawData.last_price * difference)) || 0;
                        acc += sum;
                        return acc;
                    }, 0);

                    exportData.push({
                        'Группа': category,
                        'Сумма недостачи': Math.abs(+shortage),
                    });
                }
            });

            exportData.push(
                {
                    'Группа': '',
                },
                {
                    'Группа': 'Итого',
                },
                {
                    'Группа': 'Общая сумма недостачи',
                    'Сумма недостачи': calcualteTotalSum(groupedItems, 'shortage'),
                }
            );

            return exportData;
        };

        const exportDataFirstSheet = getFirstSheet();
        const exportDataSecondSheet = getSecondSheet();

        const ws1 = utils.json_to_sheet(exportDataFirstSheet);
        const ws2 = utils.json_to_sheet(exportDataSecondSheet);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws1, "Свод по товарам");
        utils.book_append_sheet(wb, ws2, "Свод по категориям");

        writeFileXLSX(wb, `Инвентаризация № ${form.id} (Недостача).xlsx`);
    }

    const onExport = () => {
        const groupedItems = {
            'Сырье': groupedProducts.groupedRawMaterials,
            ...(viewMode !== 'view' && { 'Полуфабрикаты': groupedProducts.groupedSemiManufactures }),
        };

        const exportData = [];

        exportData.push({
            'Филиал': pointAdress || 'Нет данных',
            'Дата': dateInfo || 'Нет данных',
        });
        
        exportData.push({});

        Object.keys(groupedItems).forEach((type) => {
            if (viewMode === 'view') {
                exportData.push({
                    'Название': type,
                    'Единица измерения': '',
                    'Остаток (план.)': '',
                    'Остаток (факт.)': '',
                    'Излишки\\недостача': '',
                    'Сумма излишка\\недостачи': '',
                });
            } else {
                exportData.push({
                    'Название': type,
                    'Единица измерения': '',
                    'Введенное количество': '',
                });
            }

            Object.entries(groupedItems[type]).forEach(([category, items]) => {
                if (viewMode === 'view') {
                    exportData.push({
                        'Название': category,
                        'Единица измерения': '',
                        'Остаток (план.)': '',
                        'Остаток (факт.)': '',
                        'Излишки\\недостача': '',
                        'Сумма излишка\\недостачи': '',
                    });
                } else {
                    exportData.push({
                        'Название': category,
                        'Единица измерения': '',
                        'Введенное количество': '',
                    });
                }

                items.forEach((item) => {
                    const rawData = item.rawmaterial;
                    let unitName = MEASURES_RAW[rawData.measure] || 'Нет данных';
                    const name = rawData ? rawData.name : 'Нет данных';
                    const planBalance = parseNumToFixed(getPlanBalance(item), 3);
                    const difference = parseNumToFixed(parseFloat(item.quantity - planBalance), 3);
                    const quantity = item.quantity != null ? parseNumToFixed(item.quantity, 3) : 0;
                    
                    if (viewMode === 'view') {
                        exportData.push({
                            'Название': name,
                            'Единица измерения': unitName,
                            'Остаток (план.)': planBalance || 0,
                            'Остаток (факт.)': quantity,
                            'Излишки\\недостача': difference || 0,
                            'Сумма излишка\\недостачи': item.sum ? +item.sum : +parseNumToFixed(parseFloat(rawData.last_price * difference)) || 0,
                        });
                    } else {
                        exportData.push({
                            'Название': name,
                            'Единица измерения': unitName,
                            'Введенное количество': quantity,
                        });
                    }
                });
            });

            if (viewMode === 'view') {
                exportData.push(
                    {
                        'Название': '',
                    },
                    {
                        'Название': 'Итого',
                    },
                    {
                        'Название': 'Общая сумма излишков',
                        'Сумма излишка\\недостачи': calcualteTotalSum(groupedProducts.groupedRawMaterials, 'surplus'),
                    },
                    {
                        'Название': 'Общая сумма недостачи',
                        'Сумма излишка\\недостачи': calcualteTotalSum(groupedProducts.groupedRawMaterials, 'shortage'),
                    }
                );
            }
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Инвентаризация");

        const fileType = viewMode === 'view' ? 'с рассчитанным количеством' : 'с введенным количеством';
        writeFileXLSX(wb, `Инвентаризация № ${form.id} (${fileType}).xlsx`);
    };

    if (loading || loadingRawsForm) return <div style={styles.formLoading}><Loader text="Загрузка бланка..." /></div>

    const renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }
    const pointAdress = renderPointLabel(points.find((point) => point.id === form.point.id));

    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{ marginTop: 25 }}>
            <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                    <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
                        <div className="kt-portlet kt-portlet--mobile">
                            <div className="kt-portlet__body kt-portlet__body--fit">
                                <div
                                    style={{ position: 'relative', marginBottom: 0, minHeight: '100vh' }}
                                    className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}
                                >
                                    {isMobile ? (
                                        <>
                                            <div className="kt-subheader__mobile-wrapper">
                                                <div className="kt-subheader not-mt kt-grid__item">
                                                    <div className="kt-container kt-container--fluid">
                                                        <div className="kt-subheader__main">
                                                            <div className="kt-subheader__mobile-header">
                                                                <div className="kt-subheader__mobile-actions">
                                                                    <BackButton />
                                                                    <button className="btn btn-dark" onClick={onExport}>Экспорт</button>
                                                                    {viewMode === 'view' && <button className='btn btn-dark' onClick={onExportShortage}> Экспорт недостача </button>}
                                                                    <button className="btn btn-secondary" onClick={openChangeLog}>История изменений</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="kt-subheader__main">
                                                            <div className="kt-subheader__mobile-actions">
                                                                <div style={textStyles}>
                                                                    <span>{dateInfo}</span>
                                                                </div>
                                                                <div style={{ width: 175, ...textStyles }}>
                                                                    <span>{pointAdress}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="kt-subheader not-mt kt-grid__item">
                                                <div className="kt-container kt-container--fluid">
                                                    <div className="kt-subheader__main">
                                                        <h3 className="kt-subheader__title">Форма инвентаризации {form.id}</h3>
                                                        <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                                                        <div className="kt-subheader__group" id="kt_subheader_search">
                                                            <BackButton />
                                                            <button className="btn btn-dark" onClick={onExport}>Экспорт</button>
                                                            {viewMode === 'view' && <button className='btn btn-dark' onClick={onExportShortage}> Экспорт недостача </button>}
                                                            <button className="btn btn-secondary" onClick={openChangeLog}>История изменений</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="kt-subheader not-mt kt-grid__item">
                                                <div className="kt-container kt-container--fluid">
                                                    <div className="kt-subheader__main">
                                                        <div style={textStyles}>
                                                            <span>{dateInfo}</span>
                                                        </div>
                                                        <div style={{ width: 175, marginLeft: 10, ...textStyles }}>
                                                            <span>{pointAdress}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <table className="kt-datatable__table">
                                        <TableHeader title="Сырье" viewMode={viewMode} isMobile={isMobile}/>
                                        <tbody className="kt-datatable__body">
                                        {isEmpty(groupedProducts.groupedRawMaterials)
                                            ? (
                                                <tr>
                                                    <td colSpan={3}>
                                                        <span className="kt-datatable--error">Нет данных о сырье</span>
                                                    </td>
                                                </tr>
                                            )
                                            : renderGroupedItems(groupedProducts.groupedRawMaterials)
                                        }
                                        </tbody>
                                    </table>
                                    {viewMode !== 'view' && (
                                        <table className="kt-datatable__table">
                                            <TableHeader title="Полуфабрикаты" viewMode={viewMode} isMobile={isMobile}/>
                                            <tbody className="kt-datatable__body">
                                            {isEmpty(groupedProducts.groupedSemiManufactures)
                                                ? (
                                                    <tr>
                                                        <td colSpan={3}>
                                                            <span className="kt-datatable--error">Нет данных о полуфабрикатах</span>
                                                        </td>
                                                    </tr>
                                                )
                                                : renderGroupedItems(groupedProducts.groupedSemiManufactures, true)
                                            }
                                            </tbody>
                                        </table>
                                    )}
                                    {!isEmpty(groupedProducts.groupedRawMaterials) && viewMode === 'view' &&
                                        <table className="kt-datatable__table">
                                            <thead className="kt-datatable__head">
                                                <tr className="kt-datatable__row">
                                                    <th colSpan={viewMode === 'view' ? 6 : 3} className="kt-datatable__cell kt-datatable__title" style={{textAlign: 'center'}}>
                                                        Итого
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="kt-datatable__body">
                                                <tr className="kt-datatable__row">
                                                    <td width="200px" className="kt-datatable__cell">
                                                        <span style={{ fontWeight: 600 }}> Общая сумма излишков </span>
                                                    </td>
                                                    <td width="auto" className="kt-datatable__cell" />
                                                    <td width="200px" className="kt-datatable__cell" />
                                                    <td width="200px" className="kt-datatable__cell" />
                                                    <td width="200px" className="kt-datatable__cell" />
                                                    <td style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                                                        <span>{calcualteTotalSum(groupedProducts.groupedRawMaterials, 'surplus')} ₽</span>
                                                    </td>
                                                </tr>
                                                <tr className="kt-datatable__row">
                                                    <td width="200px" className="kt-datatable__cell">
                                                        <span style={{ fontWeight: 600 }}> Общая сумма недостачи </span>
                                                    </td>
                                                    <td width="auto" className="kt-datatable__cell" />
                                                    <td width="200px" className="kt-datatable__cell" />
                                                    <td width="200px" className="kt-datatable__cell" />
                                                    <td width="200px" className="kt-datatable__cell" />
                                                    <td style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                                                        <span>{calcualteTotalSum(groupedProducts.groupedRawMaterials, 'shortage')} ₽</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReactTooltip effect="solid" type="dark" place="top" />
                </div>
            </div>
        </div>
    );
};

export default withRouter(DetailInventoryForm);
